// 倒计时
// function getRandomNum(min, max) {
//     return Math.floor(Math.random() * (max - min)) + min
// }

// let endTimeG

// function cutDownTime() {
//     let nowTime = new Date()
//     let endTime = new Date(endTimeG)

//     let leftTime = endTime.getTime() - nowTime.getTime()
//     if (leftTime < 0) {
//         setupNewCountdown()
//         leftTime = 0
//     }
//     let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
//         leftM = Math.floor((leftTime / (1000 * 60)) % 60),
//         leftS = Math.floor((leftTime / 1000) % 60)
//     leftH = leftH >= 10 ? leftH : '0' + leftH
//     leftM = leftM >= 10 ? leftM : '0' + leftM
//     leftS = leftS >= 10 ? leftS : '0' + leftS

//     return {
//         hour: leftH,
//         minute: leftM,
//         second: leftS,
//     }
// }
// function setupNewCountdown() {
//     const randomHour = getRandomNum(1, 9)
//     const currentTime = new Date()
//     endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
// }
// let intervalId

// function getCutDownTime() {
//     setupNewCountdown()
//     if (intervalId) clearInterval(intervalId)
//     intervalId = setInterval(function () {
//         let cutDownTimeText = cutDownTime()
//         $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
//         $('.sp_top_cut_down .sp_left_view .sp_minute').html(cutDownTimeText.minute)
//         $('.sp_top_cut_down .sp_left_view .sp_second').html(cutDownTimeText.second)
//     }, 1000)
// }

// getCutDownTime()

let prods = window.product
function getCur() {
    let color = $('#sp-color div.active').attr('data-val')
    let size = $('#sp-color2 div.active').attr('data-val')
    return prods.filter(item => item.option1 == color && item.option2 == size)[0]
}
function changePrice() {
    let num = $('#calcNumber').val()
    let price = (getCur().price*num / 100).toFixed(2).replace('.', ',')
    let compare = (getCur().compare_at_price*num / 100).toFixed(2).replace('.', ',')
    //   if(num == 1){
    //     price = (getCur().price * num / 100).toFixed(2)
    //   }else if(num == 2){
    //     price = (getCur().price * num / 100 * 0.95).toFixed(2)
    //   }else if(num == 3){
    //     price = (getCur().price * num / 100 * 0.9).toFixed(2)
    //   }else {
    //     price = (getCur().price * num / 100 * 0.85).toFixed(2)
    //   }
    // let price = getCur().price
    // let compare = getCur().compare_at_price
    //   price = (price + '').replace('.', ',')
    //   compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font =
        100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.font-off').html(off_font+"%")
}
$('.buyNow').click(function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
})
$('.sp-top-btn').click(function () {
    $.get('/api/cart', function (res) {
        let cartNum = res.cart.item_count
        let cartItem = res.cart.line_items
        var items = []
        if (cartNum > 0) {
            cartItem.forEach(function (cartItem) {
                items.push({
                    quantity: cartItem.quantity, // 数量
                    variant_id: cartItem.variant_id, // 子商品id
                })
            })
        }
        $.post(
            '/api/checkout/order',
            {
                line_items: items,
                refer_info: { source: 'buy_now' },
            },
            function (ret) {
                if (ret.state === 'success') {
                    return (window.safeHref =
                        '/checkout/' + ret.data.order_token + '?step=contact_information')
                } else {
                    $.toast.show({
                        content:
                            {
                                30003: 'Some items have been removed, please re-order',
                                line_items_variant_withdraw:
                                    'Some items have been sold out, please re-order',
                                line_items_variant_sold_out:
                                    'Some items are not in stock, please re-order',
                            }[ret.state] ||
                            ret.errors[0] ||
                            'Some items information has been updated, please re-order',
                    })
                }
            }
        )
    })
})

$('.reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
        input.value = num
        changePrice();
    }
})
$('.add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice();
    //   $("#sp_price1").html(calcTotal(price1, input.value));
    //   $("#sp_price2").html(calcTotal(price2, input.value));
})

let spImgList1 = [
    'https://cdn.shopify.com/s/files/1/0604/1485/3198/files/ce5613caf5b61b322792608f5cec7f45.png',
    'https://cdn.shopify.com/s/files/1/0604/1485/3198/files/e6f96200e0a1081d66820966ce5efc13.png',
    'https://cdn.shopify.com/s/files/1/0604/1485/3198/files/ef9e9525f4ea14c19ecd765112537ce7.png',
    'https://cdn.shopify.com/s/files/1/0604/1485/3198/files/3136dbfde3874e4fb4a7b8a7ef034650.png',
    'https://cdn.shopify.com/s/files/1/0604/1485/3198/files/4aaf404d549fa4688cde92d99d3634da.png',
]

function mainRender() {
    $(function () {
        $('#root').css('zoom', 'normal')
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)

        window.addEventListener(
            'resize',
            (function () {
                var timer
                return function () {
                    if (timer) clearTimeout(timer)
                    timer = setTimeout(function () {
                        $('#root').css('zoom', 'normal')
                        let scale = document.body.clientWidth / 1080
                        $('#root').css('zoom', scale)
                    }, 100)
                }
            })()
        )
    })

    function lazyLoadImages() {
        // 懒加载
        const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
        const config = {
            rootMargin: '0px 0px 1300px 0px',
            threshold: 0,
        }

        const lazyLoadObserver = new IntersectionObserver(function (
            entries,
            observer
        ) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    // 当图片进入视口时
                    const image = entry.target
                    const dataSrc = image.getAttribute('data-src')
                    image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
                    lazyLoadObserver.unobserve(image) // 停止观察该图片
                }
            })
        },
            config)

        images.forEach(function (image) {
            lazyLoadObserver.observe(image) // 开始观察每个图片
        })
    }

    function preloadImages(imageArray) {
        // 预加载
        // 检查数组数据结构
        if (Array.isArray(imageArray[0])) {
            // 处理二维数组
            imageArray.forEach(subArray => {
                subArray.forEach(url => {
                    const img = new Image()
                    img.src = url
                })
            })
        } else {
            // 处理一维数组
            imageArray.forEach(url => {
                const img = new Image()
                img.src = url
            })
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        lazyLoadImages()

        preloadImages(spImgList1)
        // preloadImages(spImgList);

        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]')
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault() // 阻止默认的跳转行为
                // var targetElement = document.getElementById('shopping');
                // if (targetElement) {
                //     targetElement.scrollIntoView({ behavior: 'smooth' });
                // } // 方式一
                const targetElement = document.getElementById('shopping') // 获取跳转目标节点
                const offsetTop = targetElement.offsetTop
                window.scroll({
                    top:
                        offsetTop * $('div#root').css('zoom') +
                        -254 * $('div#root').css('zoom'),
                    behavior: 'smooth', // 使用 smooth 实现平滑滚动
                }) // 方式二
            })
        })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
        console.log('Android')
    } else if (isIOS) {
        console.log('iOS')
    } else if (isPC) {
        console.log('PC')
    } else {
        $('.sp_system').css('letter-spacing', '-4px')
    }
}

mainRender()

$('.option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    // style选项
    let colorOptions = $('#sp-color .option.active').index()
    let colorOptions2 = $('#sp-color2 .option.active').index()
    $('#p-img1')[0].src = spImgList1[colorOptions]
    $('#p-img2')[0].src = spImgList1[colorOptions2]
    changePrice()
})
// 购物车加购动效
$('.cart-btn').click(function () {
    $(this).children('img').addClass('on')
    $('.sp-header-top .sp-cart .num').show()
    setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
    }, 500)
    $('.sp-header-top .sp-cart').addClass('on')
    setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
    }, 500)
})
// 处理加入购物车事件
function handleAddToCart(num) {
    if (num > 0) {
        $('#cardNum').html(num).show()
        $('.sp-top-btn').addClass('sp-high')
        $('.sp-top-btn span').html('Check out')
        $('.sp-header-top .sp-cart').addClass('on')
    } else {
        $('#cardNum').html(0).hide()

        $('.sp-top-btn').removeClass('sp-high')
        $('.sp-top-btn span').html('Buy now')
        $('.sp-header-top .sp-cart').removeClass('on')
    }
}
handleAddToCart(window.cartCount)

$('.product-part .cart-btn').click(function () {
    var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
            $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
                $('#cardNum').html(result.item_count)
            })
        },
        dataType: 'json',
    })

    var img = $('.product-part  #p-img1')
    var flyer = img[0].cloneNode(true)
    flyer.classList.add('sp-clone')

    $('#shopping').append(flyer)
    $('.sp-clone').css({
        width: img[0].width,
        height: img[0].height,
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
    })

    let finish = $('.sp-cart')
    $('.sp-clone').animate(
        {
            top: finish[0].offsetTop + $('.time-part').height(),
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
        },
        500,
        'linear',
        function () {
            $(this).animate(
                {
                    width: 0,
                    height: 0,
                    opacity: 0,
                },
                0
            )
        }
    ) // 额外

    var img2 = $('.product-part  #p-img2')
    var flyer2 = img2[0].cloneNode(true)
    flyer2.classList.add('sp-clone2')
    $('#shopping').append(flyer2)
    $('.sp-clone2').css({
        width: img2[0].width,
        height: img2[0].height,
        position: 'fixed',
        top: img2[0].offsetTop,
        left: img2.offset().left,
        'z-index': '99',
    })
    $('.sp-clone2').animate(
        {
            top: finish[0].offsetTop + $('.time-part').height(),
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
        },
        500,
        'linear',
        function () {
            $(this).animate(
                {
                    width: 0,
                    height: 0,
                    opacity: 0,
                },
                0
            )
        }
    )
})
